
	import { defineComponent, PropType } from 'vue';
	import { printHtmlElement } from '@/core/helpers/html-to-paper';
	import { useDateTime } from '@/core/hooks/use-date-time-hook';
	import {
		IBienBanResponseBase,
		IHopDongResponseBase,
		IVatTuBienBanKiemNghiemResponseBase,
	} from '@/core/interfaces/ApiResponses';
	import {
		formatQuantity,
		formatUnitPrice,
	} from '@/core/helpers/number-format';

	import DivCol from '@/layout/_shared/DivCol.vue';
	import DivRow from '@/layout/_shared/DivRow.vue';
	import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
	import PdfDocumentHeader from '@/components/shared/pdf-viewer/PdfDocumentHeader.vue';
	import { useButtonCustom } from '@/core/hooks/use-button-custom';
	import Swal from 'sweetalert2';

	export default defineComponent({
		name: 'bien-ban-print-modal',

		components: { ButtonCustom, DivCol, DivRow, PdfDocumentHeader },

		emits: ['on-close-modal'],

		setup() {
			const { moment } = useDateTime();
			const { ButtonsType } = useButtonCustom();

			return {
				moment,
				ButtonsType,
			};
		},

		props: {
			title: {
				type: String,
				default: 'Biên bản kiểm nghiệm',
			},

			bienBanData: {
				type: Object as PropType<IBienBanResponseBase | null>,
				default: () => null,
			},

			hopDongData: {
				type: Object as PropType<IHopDongResponseBase | null>,
				default: () => null,
			},

			tenDonVi: {
				type: String,
				default: '',
			},

			tenDonViCha: {
				type: String,
				default: '',
			},

			isModalOpen: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				isOpen: this.isModalOpen,
			};
		},

		watch: {
			isModalOpen(value) {
				this.isOpen = value;
			},
		},

		computed: {
			ngayBienBanDisplay() {
				if (this.bienBanData?.ngay_bien_ban) {
					const date = new Date(this.bienBanData?.ngay_bien_ban);
					return `Ngày ${date.getDate()} tháng ${
						date.getMonth() + 1
					} năm ${date.getFullYear()}`;
				}

				return '.........................';
			},

			tenGiamDocDisplay() {
				return this.bienBanData.ten_giam_doc
					? this.bienBanData.ten_giam_doc
					: '.........................';
			},

			thanhPhanItems() {
				if (!this.bienBanData?.thanh_phan_hoi_dong) return [];

				try {
					return JSON.parse(this.bienBanData?.thanh_phan_hoi_dong).filter(
						({ hoTen, chucVu, thanhPhan }) => {
							return !!hoTen || !!chucVu || !!thanhPhan;
						},
					);
				} catch (e) {
					console.error(e);

					Swal.fire({
						icon: 'error',
						title: 'Lỗi dữ liệu',
						text: 'Không thể phân tích thành phần hội đồng. Dữ liệu không hợp lệ.',
					});

					return [];
				}
			},

			ngayHopDongDisplay() {
				if (this.hopDongData?.ngay_ky) {
					return this.moment(this.hopDongData?.ngay_ky).format(
						'DD/MM/YYYY',
					);
				}

				return '.......................';
			},
		},

		methods: {
			formatQuantity,
			donGiaVatTuDisplay(vatTu: IVatTuBienBanKiemNghiemResponseBase) {
				const vatTuNhapKho =
					this.bienBanData.phieu_nhap_kho.vat_tu_nhap_kho.find(
						({ id }) => id === vatTu.id,
					);

				return formatUnitPrice(+vatTuNhapKho.pivot.don_gia);
			},
			onClose() {
				this.$emit('on-close-modal');
			},
			onPrintingButtonClicked(): void {
				printHtmlElement('bien-ban-kiem-nghiem-printing-modal');
			},
		},
	});
